import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const OperationTheatreTechnologyCoursePage: React.FC = () => {
  const otTechnologyData = {
    title: "Bachelor of Science in Operation Theatre & Anaesthesia Technology",
    shortName: "B.Sc OTT",
    duration: "3 Years",
    description: "A specialized program training students in operating room procedures, anesthesia assistance, and surgical support technology.",
    overview: "B.Sc Operation Theatre & Anaesthesia Technology prepares students to work as skilled technicians in operating rooms and anesthesia departments. Students learn about surgical procedures, anesthesia equipment operation, sterile techniques, patient monitoring, and emergency protocols. The program combines theoretical knowledge with extensive hands-on training in modern operating theaters and anesthesia delivery systems.",
    eligibility: [
      "Completed 10+2 with Physics, Chemistry, and Biology",
      "Minimum 50% aggregate marks (45% for SC/ST/OBC)",
      "Age: 17-25 years",
      "Medical fitness certificate required",
      "Good physical and mental stamina",
      "Ability to work under pressure"
    ],
    careerProspects: {
      roles: [
        "Operation Theatre Technician",
        "Anesthesia Technician",
        "Surgical Technologist",
        "Scrub Technician",
        "Perioperative Care Specialist",
        "Central Sterile Processing Technician",
        "Surgical Assistant",
        "OT Equipment Technician",
        "Surgical Coordinator",
        "OT Supervisor"
      ],
      industries: [
        "Hospitals and Surgical Centers",
        "Specialty Surgical Clinics",
        "Government Medical Colleges",
        "Private Healthcare Facilities",
        "Emergency Care Centers",
        "Ambulatory Surgery Centers",
        "Medical Equipment Companies",
        "Teaching Hospitals",
        "Research Institutions",
        "Military Medical Services"
      ],
      averageSalary: "₹3.5-8 LPA (varies by experience and specialization)",
      topRecruiters: [
        "Apollo Hospitals",
        "Fortis Healthcare",
        "Max Healthcare",
        "AIIMS",
        "Manipal Hospitals",
        "Medanta The Medicity",
        "Narayana Health",
        "Government Hospitals",
        "Specialty Surgical Centers",
        "Medical Equipment Companies"
      ]
    },
    curriculum: [
      {
        year: 1,
        subjects: [
          "Human Anatomy",
          "Human Physiology",
          "Biochemistry",
          "Microbiology",
          "Basic Pharmacology",
          "Medical Terminology",
          "Communication Skills",
          "Healthcare Systems"
        ]
      },
      {
        year: 2,
        subjects: [
          "Surgical Techniques",
          "Anesthesia Technology",
          "Operating Room Management",
          "Sterilization Techniques",
          "Surgical Instrumentation",
          "Patient Monitoring",
          "Emergency Procedures",
          "Infection Control"
        ]
      },
      {
        year: 3,
        subjects: [
          "Advanced Surgical Procedures",
          "Specialty Anesthesia",
          "Critical Care Technology",
          "Equipment Maintenance",
          "Quality Assurance",
          "Clinical Training",
          "Research Methodology",
          "Professional Ethics"
        ]
      }
    ],
    admissionProcess: [
      "Apply to medical colleges offering B.Sc OTT",
      "Merit-based selection or entrance examination",
      "Medical fitness and psychological assessment",
      "Document verification",
      "Fee payment and admission",
      "Orientation and safety training",
      "Begin theoretical and practical training",
      "Complete mandatory clinical rotations"
    ],
    topColleges: [
      {
        name: "All India Institute of Medical Sciences",
        location: "New Delhi",
        fees: "₹8,000 PA",
        ranking: "Premier Government Institute"
      },
      {
        name: "Christian Medical College",
        location: "Vellore, Tamil Nadu",
        fees: "₹1.8 LPA",
        ranking: "Top Private Medical College"
      },
      {
        name: "Kasturba Medical College",
        location: "Manipal, Karnataka",
        fees: "₹4 LPA",
        ranking: "Deemed University"
      },
      {
        name: "JSS Medical College",
        location: "Mysore, Karnataka",
        fees: "₃.5 LPA",
        ranking: "Well Established"
      }
    ],
    skills: [
      "Surgical Instrumentation",
      "Sterile Technique",
      "Anesthesia Equipment Operation",
      "Patient Positioning",
      "Emergency Response",
      "Team Coordination",
      "Attention to Detail",
      "Physical Stamina",
      "Stress Management",
      "Technical Proficiency",
      "Safety Protocols",
      "Quick Decision Making"
    ],
    futureScope: "Operation Theatre Technology is evolving with robotic surgery, minimally invasive techniques, and advanced monitoring systems. Future opportunities include specialization in cardiac surgery, neurosurgery, robotic surgery assistance, and advanced anesthesia technology. The integration of AI and IoT in surgical environments is creating new roles in surgical technology management and data analysis.",
    faqs: [
      {
        question: "What are the working conditions in operation theatres?",
        answer: "OT technicians work in sterile, controlled environments with strict protocols. The work involves long hours on feet, handling of surgical instruments, and maintaining sterile conditions. It requires physical stamina and ability to work under pressure."
      },
      {
        question: "Is there risk of infection or exposure?",
        answer: "With proper training and adherence to safety protocols, infection risk is minimal. All procedures follow strict sterile techniques and safety guidelines to protect both patients and healthcare workers."
      },
      {
        question: "Can I specialize in specific surgical areas?",
        answer: "Yes, you can specialize in areas like cardiac surgery, neurosurgery, orthopedic surgery, or pediatric surgery through additional training and experience in those departments."
      },
      {
        question: "What are the shift timings like?",
        answer: "OT technicians typically work in shifts including day, evening, night, and weekend duties. Emergency cases may require on-call availability."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {otTechnologyData.title} ({otTechnologyData.shortName})
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={otTechnologyData} />
      </div>
    </div>
  );
};

export default OperationTheatreTechnologyCoursePage;